/**
 * NewsletterForm - Newsletter subscription form (React 19)
 *
 * Uses useNewsletterForm hook with useActionState pattern.
 * Form uses native action attribute for React 19 form handling.
 * UI components from @/components/ui/ (Infrastructure)
 */

import { Button, Input } from '../../../Theme'
import { useNewsletterForm } from '../../hooks'

/**
 * Newsletter subscription form
 *
 * React 19 pattern:
 * - Uses <form action={...}> instead of onSubmit
 * - Form data extracted from FormData in hook
 * - isPending from useActionState handles loading state
 */
export function NewsletterForm() {
  const { submitAction, isPending, error, success } = useNewsletterForm()

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <form
        action={submitAction}
        className="w-full flex flex-col md:flex-row items-center justify-center gap-3"
      >
        <div className="w-full md:max-w-md">
          <label htmlFor="newsletter-email" className="sr-only">Adresa de email</label>
          <Input
            id="newsletter-email"
            name="email"
            type="email"
            placeholder="Adresa de email"
            disabled={isPending}
            required
            aria-describedby={error ? 'newsletter-error' : undefined}
          />
        </div>
        <Button variant="newsletter" type="submit" disabled={isPending}>
          {isPending ? 'Asteapta...' : 'Inscrie-te'}
        </Button>
      </form>

      {error && (
        <div id="newsletter-error" role="alert" className="text-red-500 mt-2 font-main-font text-sm">
          {error}
        </div>
      )}

      {success && (
        <div role="status" className="text-green-500 mt-2 font-main-font text-sm">
          Te-ai inscris cu succes!
        </div>
      )}
    </div>
  )
}
